import React from 'react';

class WarningText extends React.Component {

  render() {
    const {text} = this.props;
    return (
      <span className="txt-error">
        <svg className="bmw-icon-sm mr-1" aria-hidden="true"><use xlinkHref="#icon-error"/></svg>
        <span>{text}</span>
      </span>
    )
  }
}

export default WarningText;



// WEBPACK FOOTER //
// ./src/components/common/text/WarningText.js